import { Tooltip } from "@mui/material";
import AvatarName from "./AvatarName";
import { ReactComponent as EmailIcon } from "../../assets/images/emailCustomerCard.svg";
import { ReactComponent as PhoneIcon } from "../../assets/images/PhoneIconCustomerCard.svg";

const GetPersonAvatar = ({ personList, header, rowKey, isDetailsVisible, setDetailsVisible }) => {
  const toggleDetails = (event, header, rowKey, eachInput) => {
    event.stopPropagation();
    setDetailsVisible((prevState) => !prevState);
  };

  return (
    <div className="w-full">
      <div className="pt-1 space-x-1 flex items-end">
        {Array.isArray(personList) &&
          personList
            ?.filter((assigned, index) => index < 3)
            .map((eachInput, index) => {
              const initials = eachInput.name
                .split(" ")
                .filter((word) => word.length > 0)
                .map((word) => word.charAt(0).toUpperCase())
                .slice(0, 2)
                .join("");
              const fullName = eachInput.name;

              return (
                <div key={index} className="relative">
                  <Tooltip
                    title={
                      <>
                        <div className="py-2 min-w-[249px]">
                          <div className="rounded-lg bg-white">
                            <div className="border-b-2 space-y-2 pb-2">
                              <div className="flex px-2 space-x-2">
                                <div>
                                  <AvatarName
                                    name={initials}
                                    size="small"
                                    bgColor={"#E8ECF299"}
                                    textColor={"#7C7C83"}
                                    borderColor={"#ABABAC"}
                                  />
                                </div>
                                <div className="text-2999BC text-14">{fullName}</div>
                              </div>

                              <div className="flex px-2 space-x-2 my-2">
                                <div className="w-5 text-center">
                                  <EmailIcon />
                                </div>
                                <div className="text-F16136 text-12">{eachInput?.email}</div>
                              </div>

                              <div className="flex px-2 space-x-2 my-2">
                                <div className="w-5 text-center">
                                  <PhoneIcon />
                                </div>
                                <div className="text-F16136 text-12">
                                  {eachInput.mobile ? eachInput?.mobile : "Not Avaliable"}
                                </div>
                              </div>
                            </div>
                            <div className="flex justify-end mt-2 me-5 text-12">
                              <button
                                className="text-blue-500"
                                onClick={(e) => toggleDetails(e, header, rowKey, eachInput)}
                              >
                                {isDetailsVisible ? "Show more" : "Show more"}
                              </button>
                            </div>
                          </div>
                          <div></div>
                        </div>
                      </>
                    }
                    PopperProps={{ style: { zIndex: 99999 } }}
                    placement="top"
                    arrow
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: "common.white",
                          filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                          color: "#383838",
                          "& .MuiTooltip-arrow": {
                            color: "common.white",
                            filter: "drop-shadow(0px 0px 10px rgba(44, 73, 93, 0.30))",
                          },
                        },
                      },
                    }}
                  >
                    <div
                      className={` ${eachInput?.c_key ? "text-white border-white" : "text-primary-text border-primary-active hover:border-primary-30"} text-xs font-400   p-[10px] w-7 h-7 flex items-center justify-center rounded-full border-[1px]`}
                      style={{ backgroundColor: eachInput?.c_key ? eachInput?.c_key : "var(--color-primary-hover)" }}
                    >
                      {initials}
                    </div>
                  </Tooltip>

                  {/* <button
                className="absolute top-[-4px] right-[-4px] bg-blue-500 text-white rounded-full w-[10px] h-[10px] flex items-center justify-center text-xs cursor-pointer"
              // onClick={(e) => handleSelectPerson(e, eachInput)} */}
                  {/* >
                &times;
              </button> */}
                </div>
              );
            })}

        {personList?.length > 3 && (
          <div className="">
            <div className=" text-gray-500 text-12 font-600 border-primary-50 w-7 h-7 flex items-center justify-center  ">
              +{personList?.length - 3}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default GetPersonAvatar;
